var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentRequest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 73 73",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "the-modern-web/payment-request-api") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "the-modern-web/payment-request-api",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "container",
    transform: "translate(2.000000, 2.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    stroke: "#34180A",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "mask",
    x: -1,
    y: -1,
    width: 71,
    height: 71,
    rx: 14
  })), /*#__PURE__*/React.createElement("g", {
    id: "debit-card",
    transform: "translate(15.000000, 14.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.3153241,12.5251003 L33.3794605,4.57413959 L33.3794605,36.4360484 L44,36.4360484 L44,18.9808646 C44,16.5571949 43.0334935,14.2336887 41.3153241,12.5251003 Z",
    id: "Shape",
    fill: "#FFB782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.20288744,30.6303315 L0.203520885,15.0559016 C-0.398622236,13.4924778 0.380331541,11.7362753 1.94462623,11.1338418 L30.2616132,0.226456926 C31.8250369,-0.37568627 33.5812394,0.403267507 34.1833826,1.96756227 L40.1827492,17.5419922 C40.7848924,19.105416 40.0059386,20.8616185 38.4416438,21.4640519 L10.1255279,32.3714369 C8.56123311,32.97358 6.80590157,32.1937553 6.20288744,30.6303315 Z",
    id: "Shape",
    fill: "#DE4C3C"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#7A4930",
    points: "36.3454656 7.57817782 2.39289481 20.7388091 4.6536898 26.6075275 38.6077122 13.452993"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000290329392,19.7464633 L0.000290329392,3.05687815 C0.000290329392,1.3810969 1.35903186,0.0223553446 3.03481311,0.0223553446 L33.3794605,0.0223553446 C35.0552418,0.0223553446 36.4139833,1.3810969 36.4139833,3.05687815 L36.4139833,19.7464633 C36.4139833,21.4222445 35.0552418,22.780986 33.3794605,22.780986 L3.03481311,22.780986 C1.35903186,22.780986 0.000290329392,21.4222445 0.000290329392,19.7464633 Z",
    id: "Shape",
    fill: "#4398D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3794605,0.0223553446 L30.1553526,0.0223553446 L7.3967219,22.780986 L33.3794605,22.780986 C35.0552418,22.780986 36.4139833,21.4222445 36.4139833,19.7464633 L36.4139833,3.05687815 C36.4139833,1.3810969 35.0552418,0.0223553446 33.3794605,0.0223553446 Z",
    id: "Shape",
    fill: "#3E8CC7"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#5EB3D1",
    points: "3.03481311 12.1601562 6.06933592 12.1601562 6.06933592 13.6774177 3.03481311 13.6774177"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#5EB3D1",
    points: "3.03481311 16.7119404 6.06933592 16.7119404 6.06933592 18.2292019 3.03481311 18.2292019"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#5EB3D1",
    points: "16.6898755 16.7119404 19.7243982 16.7119404 19.7243982 18.2292019 16.6898755 18.2292019"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#5EB3D1",
    points: "7.58659736 12.1601562 10.6208299 12.1601562 10.6208299 13.6774177 7.58659736 13.6774177"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#5EB3D1",
    points: "12.1380912 12.1601562 15.172614 12.1601562 15.172614 13.6774177 12.1380912 13.6774177"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#5EB3D1",
    points: "16.6898755 12.1601562 19.7243982 12.1601562 19.7243982 13.6774177 16.6898755 13.6774177"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#5EB3D1",
    points: "31.1035684 3.05687815 32.6208299 3.05687815 32.6208299 5.33277027 31.1035684 5.33277027"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#5EB3D1",
    points: "28.0690456 3.05687815 29.586307 3.05687815 29.586307 5.33277027 28.0690456 5.33277027"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#5EB3D1",
    points: "25.0345228 3.05687815 26.5517842 3.05687815 26.5517842 5.33277027 25.0345228 5.33277027"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#5EB3D1",
    points: "22.0002903 3.05687815 23.5172614 3.05687815 23.5172614 5.33277027 22.0002903 5.33277027"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#88B337",
    points: "30.3449377 36.4360484 44 36.4360484 44 44.022065 30.3449377 44.022065"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1184016,13.7267736 C26.8316617,12.4446791 24.7494194,12.4484533 23.4673248,13.7351932 C22.2276182,14.9792546 22.1846495,16.9781725 23.3694837,18.2747836 L29.586307,25.0568781 C27.7177471,28.3271484 27.7975876,32.3598237 29.7933119,35.5537373 L30.3449377,36.4360484 L40.2068465,36.4360484 L40.2068465,25.8155089 L28.1184016,13.7267736 Z",
    id: "Shape",
    fill: "#FFB782"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#6B962A",
    points: "32.6208299 38.7119404 34.1380912 38.7119404 34.1380912 40.2292019 32.6208299 40.2292019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.03481311,7.91205659 L3.03481311,4.27074539 C3.03481311,3.60008446 3.57801943,3.05687815 4.24868028,3.05687815 L7.88999155,3.05687815 C8.56065249,3.05687815 9.10356841,3.60008446 9.10356841,4.27074539 L9.10356841,7.91205659 C9.10356841,8.58271745 8.56065249,9.12592376 7.88999155,9.12592376 L4.24868028,9.12592376 C3.57801943,9.12592376 3.03481311,8.58271745 3.03481311,7.91205659 Z",
    id: "Shape",
    fill: "#FDB62F"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FD7B2F",
    points: "3.03481311 5.33277027 5.31070524 5.33277027 5.31070524 6.85003164 3.03481311 6.85003164"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FD7B2F",
    points: "6.82796668 5.33277027 9.10356841 5.33277027 9.10356841 6.85003164 6.82796668 6.85003164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4482158,25.8155089 C39.2473079,25.8155089 39.0539485,25.7356683 38.9119774,25.5931166 L35.8774546,22.5585938 C35.5862542,22.2575222 35.5946738,21.7773173 35.8966163,21.4858266 C36.1910104,21.2021748 36.6566987,21.2021748 36.9502217,21.4858266 L39.9847445,24.5203494 C40.2805901,24.8170661 40.2805901,25.2972709 39.9847445,25.5931166 C39.8419025,25.7356683 39.6494141,25.8155089 39.4482158,25.8155089 Z",
    id: "Shape",
    fill: "#F2A46F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentRequest);
export default __webpack_public_path__ + "static/media/payment-request.78aad3e54a6a4e8f1ddccc9460b02bdc.svg";
export { ForwardRef as ReactComponent };